import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "mc_cart_v1";

const load = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);

  useEffect(() => localStorage.setItem(KEY, JSON.stringify(items)), [items]);

  const add = (p, qty = 1) =>
    setItems((cur) => {
      const ex = cur.find((i) => i.product_id === p.id);
      if (ex) {
        return cur.map((i) =>
          i.product_id === p.id ? { ...i, max: p.quantity, quantity: Math.min(p.quantity, i.quantity + qty) } : i
        );
      }
      return [
        ...cur,
        {
          product_id: p.id, name: p.name, price: p.price, weight_g: p.weight_g,
          image: p.images?.[0] || null, max: p.quantity, quantity: Math.min(p.quantity, qty),
        },
      ];
    });

  const update = (id, qty) =>
    setItems((cur) => cur.map((i) => (i.product_id === id ? { ...i, quantity: Math.max(1, Math.min(i.max, qty)) } : i)));
  const remove = (id) => setItems((cur) => cur.filter((i) => i.product_id !== id));
  const clear = () => setItems([]);

  const totals = useMemo(
    () => ({
      count: items.reduce((s, i) => s + i.quantity, 0),
      subtotal: items.reduce((s, i) => s + i.price * i.quantity, 0),
      weight: items.reduce((s, i) => s + i.weight_g * i.quantity, 0),
    }),
    [items]
  );

  return (
    <CartContext.Provider value={{ items, add, update, remove, clear, ...totals }}>{children}</CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
